<template>
  <div
    :style="backgroundImage"
    class="CardBasicInfoThumbnail"
  />
</template>

<script>
import { noBackgroundImage } from '@/utils/style';

export default {
  name: 'CardBasicInfoThumbnail',
  props: {
    image: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      url: 'http://dev.misijaweb.com/rae/api/',
    };
  },
  computed: {
    backgroundImage() {
      return noBackgroundImage(this.url + this.image);
    },
  },
};
</script>

<style scoped lang="scss">
.CardBasicInfoThumbnail {
  height: 60px;
  width: 150px;
  display: block;
  background-size: contain;
  background-position: 0 center;
  background-repeat: no-repeat;
}
</style>
